import { render, staticRenderFns } from "./addCase.vue?vue&type=template&id=a54849d4&scoped=true&"
import script from "./addCase.vue?vue&type=script&lang=js&"
export * from "./addCase.vue?vue&type=script&lang=js&"
import style0 from "./addCase.vue?vue&type=style&index=0&id=a54849d4&prod&scoped=true&lang=css&"
import style1 from "./addCase.vue?vue&type=style&index=1&id=a54849d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54849d4",
  null
  
)

export default component.exports